import React, { useState, useEffect } from "react";
import { Grid, ListItem, Divider, TextField } from "@mui/material";
import { Prevalidate } from "../../question/component/prevalidate";
import { DropdownButton } from "components/alove/DropDownButton";
const MDButton = require("components/MDButton").default;
const MDTypography = require("components/MDTypography").default;
import { NextScreenEvent } from "models/content/Comm";
import { PostConditionAction } from "models/batch/BatchContent";
import { ActionSetting } from "layouts/screens/screenView/components/action";
import { Action } from "models/content/Comm";

// Helper to get NextScreenEvent options
const nextScreenEventOptions = Object.values(NextScreenEvent).map((value) => ({
  label: value,
  value,
}));

export const PostActionEditor = ({
  postActions,
  updatePostActions,
}: {
  postActions: PostConditionAction[];
  updatePostActions: (actions: PostConditionAction[]) => Promise<void>;
}) => {
  const [actionsState, setActionsState] = useState<PostConditionAction[]>([]);

  useEffect(() => {
    setActionsState(postActions);
  }, [postActions]);

  const handleSave = () => {
    updatePostActions(actionsState);
  };

  const handlePreValidationChange = async (idx: number, preValidation: any) => {
    const updated = [...actionsState];
    updated[idx] = { ...updated[idx], content: preValidation[0]?.content || [], operand: preValidation[0]?.operand || "AND", action: updated[idx].action };
    setActionsState(updated);
  };

  const handleActionChange = (idx,action: Action) => {
    const updated = [...actionsState];
    updated[idx] = {
      ...updated[idx],
      action: action
    };
    setActionsState(updated);
  };

  const addPostAction = () => {
    setActionsState([
      ...actionsState,
      {
        action: { nextEventType: NextScreenEvent.none, actionUrl: "" },
      } as PostConditionAction,
    ]);
  };

  const removePostAction = (idx: number) => {
    setActionsState(actionsState.filter((_, i) => i !== idx));
  };

  return (
    <Grid container direction="column" gap={2}>
      {actionsState.map((action, idx) => (
        <React.Fragment key={idx}>
          <ListItem alignItems="flex-start">
            <Grid container spacing={2} alignItems="center">
            <Grid size={12}>
                <ActionSetting
                  action={action.action}
                  setAction={(action) => handleActionChange(idx, action)}
                  screens={[]}
                />
              </Grid>
              <Grid size={12}>
                {/* Reuse Prevalidate for the pre-validation part, but only for this action */}
                <Prevalidate
                  preValidation={[
                    { content: action.content || [], operand: action.operand },
                  ]}
                  onChange={(preValidation) => handlePreValidationChange(idx, preValidation)}
                />
              </Grid>
              
            </Grid>
          </ListItem>
          <Divider />
        </React.Fragment>
      ))}
      <Grid>
        <MDButton color="primary" variant="outlined" onClick={addPostAction}>
          Add Post Action
        </MDButton>
      </Grid>
      <Grid>
        <MDButton color="primary" variant="contained" onClick={handleSave}>
          Save
        </MDButton>
      </Grid>
    </Grid>
  );
};

export default PostActionEditor;
